var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "省份",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "province"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "请选择省份" },
                              on: { change: _vm.backProvince },
                              model: {
                                value: _vm.model.province,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "province", $$v)
                                },
                                expression: "model.province"
                              }
                            },
                            _vm._l(_vm.provinceOptions, function(d) {
                              return _c(
                                "a-select-option",
                                { key: d.id, attrs: { value: d.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "城市",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "city"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "请选择城市" },
                              on: { change: _vm.backCity },
                              model: {
                                value: _vm.model.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "city", $$v)
                                },
                                expression: "model.city"
                              }
                            },
                            _vm._l(_vm.cityOptions, function(d) {
                              return _c(
                                "a-select-option",
                                { key: d.id, attrs: { value: d.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "厂区编码",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "code"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入厂区编码" },
                            on: { change: _vm.backFactoryCode },
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "code", $$v)
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "厂区名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入厂区名称" },
                            on: { change: _vm.backFactoryName },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }